import React from 'react';
import './styles.css';
import { Tooltip, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const PageLayout = ({ children, pageName, backButton }) => {
  const history = useHistory();

  return (
    <div className="page-layout-container">
      {pageName ? (
        <div className="page-title headline-2">
          {backButton ? (
            <div className="button-wrapper">
              <Tooltip title="Volver">
                <Button
                  className="circle-button"
                  shape="circle"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => history.goBack()}
                />
              </Tooltip>
            </div>
          ) : null}
          {pageName}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default PageLayout;
